import React, { useState, useEffect } from 'react';

// 👑 阁下，这里增加了 openPayModal 参数，确保与 App.js 连通
function Order({ cart, setCart, orderStatus, setOrderStatus, socket, submitOrder, openPayModal }) {
  const [currentOrderId, setCurrentOrderId] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const total = cart.reduce((sum, item) => sum + item.price, 0);

  // 监听订单状态更新
  useEffect(() => {
    if (socket && currentOrderId) {
      socket.on('order_status_update', (data) => {
        if (data.order_id === currentOrderId) {
          setOrderStatus(data.status);
        }
      });
    }
  }, [socket, currentOrderId, setOrderStatus]);

  // 🟢 状态 2：已付款，排队等待中
  if (orderStatus === "queuing") {
    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <h2 style={{ fontSize: "32px", fontWeight: "900", color: "#8b2e1f", textShadow: "2px 2px 0 #000", marginTop: "30px" }}>💳 支付成功！</h2>
        <div style={{ border: "5px solid #000", background: "#fff", padding: "30px", margin: "30px 0", boxShadow: "8px 8px 0 #000" }}>
          <h3 style={{ fontSize: "24px", fontWeight: "900", margin: "0 0 10px 0" }}>当前状态：⏳ 排队等待中</h3>
          <p style={{ fontWeight: "bold", color: "#666", fontSize: "16px" }}>订单已同步至放克档口 iPad，请留意叫号。</p>
        </div>
        
        <button 
          onClick={() => setOrderStatus("preparing")} 
          style={{ marginTop: "40px", background: "#ddd", border: "2px dashed #000", padding: "10px", fontWeight: "bold", cursor: "pointer" }}
        >
          [测试模拟] 店长在 iPad 点击"开始制作"
        </button>
      </div>
    );
  }

  // 🔴 状态 3：前台正在火热制作中
  if (orderStatus === "preparing") {
    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <h2 style={{ fontSize: "32px", fontWeight: "900", color: "#ffb300", textShadow: "2px 2px 0 #000", WebkitTextStroke: "1px #000", marginTop: "30px" }}>🔥 火热制作中！</h2>
        <div style={{ border: "5px solid #000", background: "#fff", padding: "30px", margin: "30px 0", boxShadow: "8px 8px 0 #000" }}>
          <h3 style={{ fontSize: "24px", fontWeight: "900", margin: "0 0 10px 0" }}>当前状态：🌭 正在出炉</h3>
          <p style={{ fontWeight: "bold", color: "#666", fontSize: "16px" }}>滋滋冒油中，请准备取餐！</p>
        </div>
        
        <button 
          onClick={() => { 
            setCart([]); 
            setOrderStatus("cart"); 
            setCurrentOrderId(null);
          }} 
          style={{ width: "100%", background: "#ffd54f", border: "4px solid #000", padding: "15px", fontSize: "20px", fontWeight: "900", cursor: "pointer", boxShadow: "4px 4px 0 #000", marginTop: "20px" }}
        >
          完成取餐 (返回重新点单)
        </button>
      </div>
    );
  }

  // 🟡 状态 4：请取餐
  if (orderStatus === "ready_for_pickup") {
    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <h2 style={{ fontSize: "32px", fontWeight: "900", color: "#4CAF50", textShadow: "2px 2px 0 #000", marginTop: "30px" }}>📢 请取餐！</h2>
        <div style={{ border: "5px solid #000", background: "#fff", padding: "30px", margin: "30px 0", boxShadow: "8px 8px 0 #000" }}>
          <h3 style={{ fontSize: "24px", fontWeight: "900", margin: "0 0 10px 0" }}>当前状态：✅ 热狗已完成</h3>
          <p style={{ fontWeight: "bold", color: "#666", fontSize: "16px" }}>请到取餐区领取您的美味热狗！</p>
        </div>
        
        <button 
          onClick={() => { 
            setCart([]); 
            setOrderStatus("cart"); 
            setCurrentOrderId(null);
          }} 
          style={{ width: "100%", background: "#4CAF50", border: "4px solid #000", padding: "15px", fontSize: "20px", fontWeight: "900", cursor: "pointer", boxShadow: "4px 4px 0 #000", marginTop: "20px" }}
        >
          确认取餐 (返回重新点单)
        </button>
      </div>
    );
  }

  // 🛒 处理支付提交逻辑
  const handlePayment = async () => {
    if (isSubmitting) return;
    
    // 👈 核心修改：点击立即下单，直接呼叫 App.js 的支付弹窗组件
    if (openPayModal) {
        openPayModal(total);
    } else {
        // 如果信号没接通，回退到原始模拟提交逻辑
        setIsSubmitting(true);
        try {
          const orderData = {
            user_id: 1,
            items: cart.map(item => ({
              product_id: item.id,
              quantity: 1,
              unit_price: item.price,
              customizations: item.selections || {}
            })),
            total_amount: total,
            order_notes: "顾客通过小程序下单"
          };
          const orderResponse = await submitOrder(orderData);
          setCurrentOrderId(orderResponse.id);
          setOrderStatus("pending_payment");
          setTimeout(() => setOrderStatus("queuing"), 2000);
        } catch (error) {
          console.error('订单提交失败:', error);
          alert('订单提交失败，请重试');
        } finally {
          setIsSubmitting(false);
        }
    }
  };

  // 🟡 状态 1：待付款显示
  if (orderStatus === "pending_payment") {
    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <h2 style={{ fontSize: "32px", fontWeight: "900", color: "#FF9800", textShadow: "2px 2px 0 #000", marginTop: "30px" }}>💳 正在处理支付...</h2>
        <div style={{ border: "5px solid #000", background: "#fff", padding: "30px", margin: "30px 0", boxShadow: "8px 8px 0 #000" }}>
          <h3 style={{ fontSize: "24px", fontWeight: "900", margin: "0 0 10px 0" }}>当前状态：⏳ 等待支付确认</h3>
          <p style={{ fontWeight: "bold", color: "#666", fontSize: "16px" }}>请向店员出示订单或扫码付款</p>
        </div>
      </div>
    );
  }

  if (cart.length === 0) {
    return (
      <div style={{ textAlign: "center", marginTop: "60px", color: "#333" }}>
        <h2 style={{ fontSize: "24px", fontWeight: "900" }}>🛒 记录仪空空如也</h2>
        <p style={{ fontWeight: "bold", color: "#555" }}>快去菜单加点放克热狗吧！</p>
      </div>
    );
  }

  return (
    <div style={{ padding: "15px", paddingBottom: "30px" }}>
      <h2 style={{ borderBottom: "4px solid #000", paddingBottom: "10px", marginTop: 0, fontWeight: "900", color: "#8b2e1f", fontSize: "22px" }}>
        🧾 当前订单明细
      </h2>
      
      {cart.map((item, index) => (
        <div key={index} style={{
          background: "#fff", border: "4px solid #000", padding: "15px",
          marginBottom: "15px", boxShadow: "4px 4px 0 #000", position: "relative"
        }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", borderBottom: "2px dashed #000", paddingBottom: "10px", marginBottom: "10px" }}>
            <strong style={{ fontSize: "20px", fontWeight: "900", lineHeight: "1" }}>{item.cn || item.name}</strong>
            <strong style={{ fontSize: "24px", color: "#ffb300", fontWeight: "900", fontFamily: '"Impact", sans-serif', WebkitTextStroke: "1px #000", lineHeight: "0.8" }}>
              ¥{item.price}
            </strong>
          </div>
          
          <div style={{ fontSize: "14px", color: "#245c3c", lineHeight: "1.6", fontWeight: "bold" }}>
            {item.selections && Object.entries(item.selections).map(([key, value]) => (
              <div key={key}>▪ {key}: <span style={{color: "#8b2e1f", fontSize: "15px"}}>{value}</span></div>
            ))}
          </div>

          <button 
            onClick={() => {
              const newCart = [...cart];
              newCart.splice(index, 1);
              setCart(newCart);
            }}
            style={{
              position: "absolute", bottom: "12px", right: "12px",
              background: "#FFF", color: "#000", border: "3px solid #000",
              fontWeight: "900", cursor: "pointer", padding: "4px 10px", boxShadow: "2px 2px 0 #000"
            }}
          >
            删 除
          </button>
        </div>
      ))}
      
      <div style={{ background: "#000", color: "#ffd54f", padding: "15px", border: "4px solid #000", display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "25px" }}>
        <span style={{ fontSize: "20px", fontWeight: "900" }}>总计:</span>
        <span style={{ fontSize: "36px", fontWeight: "900", fontFamily: '"Impact", sans-serif', WebkitTextStroke: "1px #fff" }}>¥{total}</span>
      </div>

      <button 
        onClick={handlePayment}
        disabled={isSubmitting}
        style={{
          width: "100%", 
          background: isSubmitting ? "#ccc" : "#ffd54f", 
          border: "4px solid #000",
          padding: "15px", 
          fontSize: "22px", 
          fontWeight: "900", 
          marginTop: "15px",
          boxShadow: "4px 4px 0 #000", 
          cursor: isSubmitting ? "not-allowed" : "pointer",
          opacity: isSubmitting ? 0.7 : 1
        }}
      >
        {isSubmitting ? "正在呼叫后台..." : "立 即 下 单"}
      </button>
    </div>
  );
}

export default Order;